import { Route } from '../../types/route';

class Router {
  private routeList: Route[] = [];

  isRegisteredRoute(value: string): boolean {
    return this.routeList.some(route => route.path === value);
  }

  addRoutes(route: Route[]): void {
    this.routeList.push(...route);
  }

  getRoutes(): Route[] {
    return this.routeList;
  }
}

export default Router;
